import { Loader2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Company } from '@/types';

interface CompanyDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  company: Company | null;
  onConfirm: () => void;
  userCount: number;
  gardenCount: number;
  isLoading?: boolean;
}

export function CompanyDeleteDialog({
  open,
  onOpenChange,
  company,
  onConfirm,
  userCount,
  gardenCount,
  isLoading = false,
}: CompanyDeleteDialogProps) {
  if (!company) return null;

  const hasAssociations = userCount > 0 || gardenCount > 0;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar empresa?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Estás a punto de eliminar la empresa <strong>{company.name}</strong>.
            </p>
            {hasAssociations && (
              <p className="text-destructive font-medium">
                ⚠️ Esta empresa tiene {userCount} usuario(s) y {gardenCount} jardín(es) asociados. 
                Deberás reasignarlos antes de eliminar.
              </p>
            )}
            {!hasAssociations && (
              <p>Esta acción no se puede deshacer.</p>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={hasAssociations || isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Eliminando...
              </>
            ) : (
              'Eliminar'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
